import React, { useEffect, useReducer } from 'react';
import { useHistory } from "react-router-dom";

import LearningContentCategoriesContext from '../../context/learningContentContext/learningContentCategories-context';
import learningContentReducer from '../../reducers/learningContent-reducer';
import { getStudentCoins } from '../../actions/share-actions';
import { getLearningContentCategories, GetNonTraitLearningContents } from '../../actions/learningcontent-actions';
import LearningContentCategoryHolder from './trait/LearningContentCategoryHolder';
import Loading from '../shared/Loading';
import { DefaultLayout, TabsCategory } from '../shared/component'
import NonTraitContentCategoryHolder from './nonTrait/NonTraitContentCategoryHolder';

import { getIconLearningContent } from '../../utils/helpers/icon/iconHelper';

const LearningContentCategory = () => {
    const history = useHistory();
    const [learningContentCategoriesContext, dispatch] = useReducer(learningContentReducer);
    const [loading, setLoading] = React.useState(true);

    useEffect(() => {
        const initStudentCoins = async () => {
            const response = await getStudentCoins();

            if (response.status === "Success") {
                const coins = response.data;

                dispatch({ type: 'SET_STUDENT_COINS', studentCoins: coins });
            }
        };

        const initNonTraitLearningContents = async () => {
            const learningContentResponse = await GetNonTraitLearningContents();
            if (learningContentResponse > 200 || learningContentResponse.status === "Failed") {
                return history.push("/SessionTimeOut")
            }

            let nonTraitLearningContents = learningContentResponse.data.nonTraitLearningContents;
            dispatch({ type: 'SET_NONTRAIT_LEARNING_CONTENTS', nonTraitLearningContents: nonTraitLearningContents });
        };

        const initLearningContentCategories = async () => {
            const learningContentResponse = await getLearningContentCategories();
            if (learningContentResponse > 200 || learningContentResponse.status === "Failed") {
                return history.push("/SessionTimeOut")
            }

            const result = setupLearningContetentCategories(learningContentResponse);

            dispatch({ type: 'SET_LEARNING_CONTENT_CATEGORIES', learningContentCategories: result });
            setLoading(false);
        };

        initStudentCoins();
        initNonTraitLearningContents();
        initLearningContentCategories();

    }, []);

    const setupLearningContetentCategories = (learningContentCategories) => {
        let learningContentCategoriesCustom = learningContentCategories.data.map((learningContentCat) => {
            if (learningContentCat.traitGroupName == 'Promotion of Well-being') {
                learningContentCat.logoPath = getIconLearningContent().img_lc_promotion;
                //learningContentCat.logoPath = "./assets/images/components/shared/traits/wellbeing/UI_CityIcon_Wellbeing-min.png";
            }
            else if (learningContentCat.traitGroupName == 'Mindset') {
                learningContentCat.logoPath = getIconLearningContent().img_lc_mindset;
                //learningContentCat.logoPath = "./assets/images/components/shared/traits/mindset/UI_CityIcon_Mindset-min.png";
            }
            else if (learningContentCat.traitGroupName == 'Grit and Resilience') {
                learningContentCat.logoPath = getIconLearningContent().img_lc_grit_resilience;
                //learningContentCat.logoPath = "./assets/images/components/shared/traits/resilience/UI_CityIcon_Resilience-min.png";
            }
            else if (learningContentCat.traitGroupName == 'Approaches to Learning and Studying') {
                learningContentCat.logoPath = getIconLearningContent().img_lc_approaches;
                //learningContentCat.logoPath = "./assets/images/components/shared/traits/learning/UI_CityIcon_Learning-min.png";
            }
            return learningContentCat;
        });

        const result = learningContentCategoriesCustom.map(obj1 => ({
            ...learningContentCategories.data.find((item) => (item.traitGroupId === obj1.traitGroupId) && item),
            ...obj1
        }));

        return result;
    }

    const dataTabsCategory = [
        {
            label: 'Trait Resources',
            component: <LearningContentCategoryHolder />
        },
        {
            label: 'Non-Trait Resources',
            component: <NonTraitContentCategoryHolder />
        }
    ]

    if (loading) return <Loading />

    return (
        <LearningContentCategoriesContext.Provider value={{ learningContentCategoriesContext, dispatch }}>
            <DefaultLayout
                title="Learning Resources"
                type='Learning Content'
                description='Please choose a category'
                image={getIconLearningContent().img_lc_bg_header}
            >
                <TabsCategory
                    dataTabsCategory={dataTabsCategory}
                />
            </DefaultLayout>
        </LearningContentCategoriesContext.Provider>
    )
}

export default LearningContentCategory;